module.exports =
    itemContainer: '.flipster-container'
    itemSelector: '.flipster-item'
    start: 'center'
    fadeIn: 400
    loop: true
    autoplay: false
    pauseOnHover: true
    style: 'carousel'
    spacing: -0.6
    click: true
    keyboard: false
    scrollwheel: false
    touch: true
    nav: false
    buttons: false
    buttonPrev: 'Previous'
    buttonNext: 'Next'
    onItemSwitch: false